document.addEventListener("DOMContentLoaded", function () {
  const gs = document.querySelector("#gallery");
  const vs = document.querySelector("#videoHome");

	screen.orientation.addEventListener('change', function(e) {
		if(screen.orientation.type.includes("portrait")){
			[gs, vs].forEach(el => el.classList.remove("mobile-gallery", "mobile-video"));
			return
		}
		[{el: gs, cs: "mobile-gallery"}, {el:vs, cs: "mobile-video"}].forEach(({el, cs}) => {
			el.classList.remove(cs);
			if(getElementVisibilityRatio(el) > .2){
				el.classList.add(cs);
			}
		})
	})
	function getElementVisibilityRatio(el) {
    const {top, bottom, height} = el.getBoundingClientRect();
    const visibleHeight = Math.min(window.innerHeight, bottom) - Math.max(0, top);
    const visibilityRatio = Math.max(0, visibleHeight / height);
    return visibilityRatio;
}
});


document.addEventListener("DOMContentLoaded", function () {
  const video = document.querySelector("#videoHome video");
  document
	.querySelectorAll("#videoHome .sound, #videoHome .no-sound")
    .forEach((button) => {
      button.addEventListener("click", function () {
        if (video.muted) {
          video.muted = false;
          document.querySelector("#videoHome").classList.add("with-sound");
        } else {
					video.muted = true;
          document.querySelector("#videoHome").classList.remove("with-sound");
					
        }
      });
    });
});
